import { render, staticRenderFns } from "./SearchFooter.vue?vue&type=template&id=30a34cc0"
import script from "./SearchFooter.vue?vue&type=script&lang=ts"
export * from "./SearchFooter.vue?vue&type=script&lang=ts"
import style0 from "./SearchFooter.module.scss?vue&type=style&index=0&prod&lang=scss&module=styles&external"




function injectStyles (context) {
  
  this["styles"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports